// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"28":"6f4e4aef2800feb24f0b","311":"7c69f7a7064bdce547e3","797":"3c64f241542001b8934d"}[chunkId] + ".chunk.min.js";
};